const initialState = {
    dataRecordBeingUpdated: null
}

export default initialState;
